import React from "react";

/** White surface card (§2.7): optional H2 title row with a right-side action. */
function Card({ title, action, className = "", bodyClassName = "", children }) {
  return (
    <section className={`fk-card ${className}`.trim()}>
      {title || action ? (
        <header className="fk-card__header">
          {title ? <h2 className="fk-card__title">{title}</h2> : <span />}
          {action}
        </header>
      ) : null}
      <div className={`fk-card__body ${bodyClassName}`.trim()}>{children}</div>
    </section>
  );
}

export default Card;
